// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/locates811.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9862: ONE set of 811 locate rules — 811 window, Projects, driver screen,
// the PDF reader callable and the connector.)
//
// Side-effect module: attaches `window.Locates811`. Views read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function () {
  'use strict';

  var L811_SITE_MAX = 120;
  var L811_TICKET_NO_MAX = 40;
  var L811_STORED_STATUSES = ['requested', 'clear', 'renewed'];
  var L811_STATUSES = ['requested', 'waiting', 'clear', 'expired', 'renewed']; // waiting = before the legal dig start (TASK-9920), derived
  var L811_ID_RE = /^[A-Za-z0-9_-]{1,128}$/;
  var L811_MATCH_MIN = 0.8;

  /** Trimmed one-line text, control characters and repeated spaces removed, capped. */
  function l811CleanText(v, max) {
    var s = String(v == null ? '' : v).replace(/[\u0000-\u001f\u007f]+/g, ' ').replace(/\s+/g, ' ').trim();
    return s.slice(0, max || L811_SITE_MAX).trim();
  }

  /** The site name a ticket carries: siteName, else the two old fields (read for safety). */
  function l811SiteNameOf(p) {
    if (!p || typeof p !== 'object') return '';
    return l811CleanText(p.siteName) || l811CleanText(p.pendingJobName) || l811CleanText(p.proposedProjectName);
  }

  /**
   * Grouping key for a site name: lowercase letters and digits only, so
   * "Bridger Lostwood", "bridger lost-wood" and "BRIDGER  LOSTWOOD" are one site.
   * '' = no site.
   */
  function l811SiteKey(name) {
    return String(name == null ? '' : name).toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  /** customer + site. '' when the ticket has no site name. */
  function l811GroupKey(customerId, siteName) {
    var k = l811SiteKey(siteName);
    return k ? String(customerId || '') + '|' + k : '';
  }

  /**
   * Tickets grouped by customer + normalized site. Only tickets that pass
   * `include` (default: all) and have a site name. Each group's display name is
   * the spelling most of its tickets use (ties: the first one seen).
   * Returns [{ key, customerId, siteName, ids, permits }] sorted by site name.
   */
  function l811GroupTickets(permits, include) {
    var groups = {};
    var order = [];
    var list = Array.isArray(permits) ? permits : [];
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (!p || !p.id) continue;
      if (typeof include === 'function' && !include(p)) continue;
      var name = l811SiteNameOf(p);
      var key = l811GroupKey(p.customerId, name);
      if (!key) continue;
      if (!groups[key]) { groups[key] = { key: key, customerId: p.customerId || '', ids: [], permits: [], spellings: {} }; order.push(key); }
      var g = groups[key];
      g.ids.push(p.id);
      g.permits.push(p);
      g.spellings[name] = (g.spellings[name] || 0) + 1;
    }
    var out = [];
    for (var j = 0; j < order.length; j++) {
      var gg = groups[order[j]];
      var best = '';
      var bestN = 0;
      for (var s in gg.spellings) {
        if (Object.prototype.hasOwnProperty.call(gg.spellings, s) && gg.spellings[s] > bestN) { best = s; bestN = gg.spellings[s]; }
      }
      out.push({ key: gg.key, customerId: gg.customerId, siteName: best, ids: gg.ids, permits: gg.permits });
    }
    out.sort(function (a, b) { return a.siteName.toLowerCase() < b.siteName.toLowerCase() ? -1 : (a.siteName.toLowerCase() > b.siteName.toLowerCase() ? 1 : 0); });
    return out;
  }

  /** The ticket number a file name LEADS with ("26139870_Bridger Lostwood.pdf"): 5+ digits. */
  function l811TicketNoFromFile(fileName) {
    var m = /^\s*(\d{5,})(?!\d)/.exec(String(fileName || ''));
    return m ? m[1].slice(0, L811_TICKET_NO_MAX) : '';
  }

  /** The site part of "ticket#_site.pdf" ("Bridger Lostwood"), or ''. Needs the leading ticket #. */
  function l811SiteFromFile(fileName) {
    var base = String(fileName || '').replace(/\.pdf$/i, '');
    var m = /^\s*\d{5,}(?!\d)[\s_\-.]*(.*)$/.exec(base);
    if (!m) return '';
    return l811CleanText(m[1].replace(/_+/g, ' '), L811_SITE_MAX);
  }

  /** A real calendar date key ('2026-02-31' is not). */
  function l811ValidDateKey(v) {
    if (typeof v !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(v)) return '';
    var ms = Date.UTC(+v.slice(0, 4), +v.slice(5, 7) - 1, +v.slice(8, 10));
    return new Date(ms).toISOString().slice(0, 10) === v ? v : '';
  }

  function l811AddDays(key, n) {
    if (!l811ValidDateKey(key) || typeof n !== 'number' || !isFinite(n)) return '';
    var ms = Date.UTC(+key.slice(0, 4), +key.slice(5, 7) - 1, +key.slice(8, 10)) + Math.round(n) * 86400000;
    return new Date(ms).toISOString().slice(0, 10);
  }

  /** Today's date key in the company's time zone (default Central). */
  function l811TodayKey(tz, now) {
    var d = now instanceof Date ? now : new Date(typeof now === 'number' ? now : Date.now());
    try {
      var parts = new Intl.DateTimeFormat('en-CA', { timeZone: tz || 'America/Chicago', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d);
      var g = function (t) { for (var i = 0; i < parts.length; i++) if (parts[i].type === t) return parts[i].value; return ''; };
      return g('year') + '-' + g('month') + '-' + g('day');
    } catch (e) {
      return d.toISOString().slice(0, 10);
    }
  }

  // TASK-9887 — month names too ("Oct 19, 2026", "October 19 2026", "19 Oct
  // 2026", "Oct. 19th, 26"): the E2E's sideways ticket printed them and the
  // reader returned no dates at all.
  var L811_MONTH_NAMES = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
  /** 1-12 for "Oct" / "October" / "Sept" (a real month name or its 3+ letter start), else 0. */
  function l811MonthNo(w) {
    var s = String(w || '').toLowerCase();
    if (s.length < 3) return 0;
    for (var i = 0; i < 12; i++) if (L811_MONTH_NAMES[i].indexOf(s) === 0) return i + 1;
    return 0;
  }
  /** The printed date at the START of s: { key, len } (len = characters used), or null. */
  function l811PrintedDateAt(s) {
    var raw = String(s || '');
    // A leading weekday is skipped: "Monday, October 19, 2026".
    var t = raw.replace(/^\s+/, '').replace(/^(?:mon|tue|tues|wed|thu|thur|thurs|fri|sat|sun)(?:day|nesday|rsday|urday)?\.?,?\s+(?=[a-z])/i, '');
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(t);
    var y, mo, d;
    if (m) { y = +m[1]; mo = +m[2]; d = +m[3]; }
    else if ((m = /^(\d{1,2})[\/\-.](\d{1,2})[\/\-.](\d{2,4})/.exec(t))) { mo = +m[1]; d = +m[2]; y = +m[3]; }
    else if ((m = /^([A-Za-z]{3,9})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4}|\d{2})(?!\d)/.exec(t)) && l811MonthNo(m[1])) { mo = l811MonthNo(m[1]); d = +m[2]; y = +m[3]; }
    else if ((m = /^(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3,9})\.?,?\s+(\d{4}|\d{2})(?!\d)/.exec(t)) && l811MonthNo(m[2])) { d = +m[1]; mo = l811MonthNo(m[2]); y = +m[3]; }
    else return null;
    if (y < 100) y += 2000;
    var key = l811ValidDateKey(y + '-' + (mo < 10 ? '0' : '') + mo + '-' + (d < 10 ? '0' : '') + d);
    return key ? { key: key, len: raw.length - t.length + m[0].length } : null;
  }
  /**
   * A printed date ("10/29/26", "10/29/2026", "2026-10-29", "Oct 29, 2026") ->
   * 'YYYY-MM-DD', or ''. Two-digit years are 20xx.
   */
  function l811PrintedDateKey(s) {
    var r = l811PrintedDateAt(s);
    return r ? r.key : '';
  }

  /**
   * Minutes after midnight for "12:01 am" / "5:30 PM" / "17:30", or -1.
   * TASK-10167: same rule as l811DigStartTimeMinutes: a 12-hour time needs its
   * am/pm (1-12); no am/pm counts only as plain 24-hour (13:00-23:59). A bare
   * "12:01" is -1, so the expiry falls to the day before (the safe side).
   * Seconds are allowed ("7:00:00 AM"); am/pm needs its m ("12:01 per" is bare).
   * The FIRST clock-like token decides, with token edges (no lookbehind: older
   * iPad Safari): "123:00", "17:3000", "7:00:99 AM" are not times -> -1, and a malformed first token is never skipped for a later one (COD).
   */
  function l811PrintedMinutes(s) {
    var m = /(?:^|[^\d:]|[a-z]:)(\d+):(\d+)(?::(\d+))?(?![\d:])(?:\s*([ap])\.?\s*m\b\.?)?/i.exec(String(s || ''));
    if (!m) return -1;
    var h = +m[1];
    var min = +m[2];
    if (m[1].length > 2 || m[2].length !== 2 || min > 59 || (m[3] != null && (m[3].length !== 2 || +m[3] > 59))) return -1;
    if (m[4]) {
      if (h < 1 || h > 12) return -1;
      var pm = m[4].toLowerCase() === 'p';
      if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12;
    } else if (h < 13 || h > 23) return -1;
    return h * 60 + min;
  }

  /**
   * The LAST good day from the ticket's printed expiration. A ticket that
   * expires early in the morning (before 6:00, e.g. "12:01 am") is not good that
   * day, so the last good day is the day before. No time printed = the day
   * before too (the safe direction). '' when the date is unreadable.
   */
  function l811GoodThroughFromPrinted(dateText, timeText) {
    var at = l811PrintedDateAt(dateText);
    if (!at) return '';
    var key = at.key;
    // The time is what follows the DATE ("Oct 19, 2026 23:59" -> "23:59").
    var mins = l811PrintedMinutes(timeText != null && timeText !== '' ? timeText : String(dateText).slice(at.len));
    if (mins >= 0 && mins >= 6 * 60) return key;
    return l811AddDays(key, -1);
  }

  /** Minutes after midnight NOW in the company zone (0-1439), or -1. */
  function l811NowMinutes(tz, now) {
    var d = now instanceof Date ? now : new Date(typeof now === 'number' ? now : Date.now());
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz || 'America/Chicago', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(d);
      var h = -1, m = -1;
      for (var i = 0; i < parts.length; i++) { if (parts[i].type === 'hour') h = +parts[i].value; if (parts[i].type === 'minute') m = +parts[i].value; }
      if (h === 24) h = 0;
      return h >= 0 && h < 24 && m >= 0 && m < 60 ? h * 60 + m : -1;
    } catch (e) {
      return -1;
    }
  }
  /**
   * TASK-9920 — the legal dig-start TIME (minutes after midnight) printed on the
   * ticket ("Work to begin 10/21/26 7:00 am" -> 420), read off the PDF. -1 when
   * no time was read, or when the printed date is not the ticket's digStartOn
   * (someone changed the date by hand, so the printed time is not for that day).
   */
  function l811DigStartMinutes(p) {
    var f = p && p.readFromPdf && typeof p.readFromPdf === 'object' && p.readFromPdf.fields && typeof p.readFromPdf.fields === 'object' ? p.readFromPdf.fields : null;
    var printed = f && typeof f.digStartPrinted === 'string' ? f.digStartPrinted : '';
    if (!printed) return -1;
    var at = l811PrintedDateAt(printed);
    if (!at || at.key !== l811ValidDateKey(p.digStartOn)) return -1;
    return l811DigStartTimeMinutes(printed.slice(at.len));
  }
  /**
   * 2090.1 (COD) — the dig-start TIME, read STRICTLY: this one decides "clear to
   * dig", so anything not plainly a time is -1 (the start day then stays not
   * clear all day). The time must be the first thing after the date (an "at" or
   * comma allowed), seconds are allowed ("7:00:00 PM"), and a 12-hour time needs
   * its am/pm; a time with no am/pm counts only when it is plainly 24-hour
   * (13:00-23:59). "123:00", "7:00", "7:00 ???" -> -1.
   */
  function l811DigStartTimeMinutes(s) {
    var m = /^[\s,]*(?:at\s+)?(\d{1,2}):(\d{2})(?::(\d{2}))?(?:\s*([ap])\.?\s*m\b\.?)?(?![\d:])/i.exec(String(s || ''));
    if (!m) return -1;
    var h = +m[1];
    var min = +m[2];
    var sec = m[3] != null ? +m[3] : 0;
    if (min > 59 || sec > 59) return -1;
    if (m[4]) {
      if (h < 1 || h > 12) return -1;
      var pm = m[4].toLowerCase() === 'p';
      if (h === 12) h = pm ? 12 : 0; else if (pm) h += 12;
    } else {
      // No am/pm: only an unambiguous 24-hour time.
      var rest = String(s).slice(m[0].length);
      if (/^\s*[a-z]/i.test(rest)) return -1; // "7:00 ???"-style trailing word: not a clean time
      if (h < 13 || h > 23) return -1;
    }
    // Seconds round UP (7:00:59 is not clear at 7:00); past 23:59 = no time.
    var total = h * 60 + min + (sec > 0 ? 1 : 0);
    return total < 1440 ? total : -1;
  }
  // ---- TASK-9922 — the dig SITE's time zone (Chris 10/16: "yes use site time zone for 811")
  // The ticket prints its work-to-begin and expiration times in the SITE's local
  // time. ND is split Central / Mountain and MT is Mountain, so a Central company
  // on a Mountain site compared in its own zone would say "Clear to dig" an hour
  // early. The site zone comes from the state + county the PDF reader stored
  // (readFromPdf.fields.state / .county).
  //
  // SOURCE: 49 CFR 71.7 (Central/Mountain boundary — ND: Yellowstone River,
  // township lines, the Little Missouri River (through McKenzie County), the
  // Missouri River to the west line of Mercer County, Morton's southwest line,
  // Sioux's north line and ND Hwy 31; SD: the Missouri River to the C&NW crossing
  // near Pierre, southwest to the north line of Jones County, then the west lines
  // of Jones, Mellette and Todd), cross-checked with the county lists in
  // Wikipedia "Mountain Time Zone" / "Time in North Dakota" (Mercer moved to
  // Central 2010-11-07, 75 FR 59914; Morton 2003; Oliver 1992). 49 CFR 71.8 for
  // KS/TX, 71.6 for the Eastern/Central states.
  //
  // A county the boundary runs THROUGH is listed as split: the reader stores the
  // county, not which side of the river the site is on, so a split county is
  // "not confident" and the fail-safe rule below decides.
  var L811_TZ = { E: 'America/New_York', C: 'America/Chicago', M: 'America/Denver', AZ: 'America/Phoenix', P: 'America/Los_Angeles', AK: 'America/Anchorage', AL: 'America/Adak', H: 'Pacific/Honolulu' };
  // One zone for the whole state (legal boundary; unofficial local practice such as
  // Phenix City AL or Kenton OK is not followed).
  var L811_STATE_ZONE = {
    CT: 'E', DE: 'E', DC: 'E', GA: 'E', ME: 'E', MD: 'E', MA: 'E', NH: 'E', NJ: 'E', NY: 'E', NC: 'E', OH: 'E', PA: 'E', RI: 'E', SC: 'E', VT: 'E', VA: 'E', WV: 'E',
    AL: 'C', AR: 'C', IL: 'C', IA: 'C', LA: 'C', MN: 'C', MS: 'C', MO: 'C', OK: 'C', WI: 'C',
    CO: 'M', MT: 'M', NM: 'M', UT: 'M', WY: 'M',
    CA: 'P', WA: 'P',
    HI: 'H',
  };
  // Split states: the zones the state spans, and (where tabled) the county rule:
  // def = the zone of every county not listed; other keys = counties in that zone;
  // split = counties the boundary runs through.
  var L811_SPLIT_STATE = {
    ND: { zones: ['C', 'M'], def: 'C', all: ['ADAMS', 'BARNES', 'BENSON', 'BILLINGS', 'BOTTINEAU', 'BOWMAN', 'BURKE', 'BURLEIGH', 'CASS', 'CAVALIER', 'DICKEY', 'DIVIDE', 'DUNN', 'EDDY', 'EMMONS', 'FOSTER', 'GOLDEN VALLEY', 'GRAND FORKS', 'GRANT', 'GRIGGS', 'HETTINGER', 'KIDDER', 'LAMOURE', 'LOGAN', 'MCHENRY', 'MCINTOSH', 'MCKENZIE', 'MCLEAN', 'MERCER', 'MORTON', 'MOUNTRAIL', 'NELSON', 'OLIVER', 'PEMBINA', 'PIERCE', 'RAMSEY', 'RANSOM', 'RENVILLE', 'RICHLAND', 'ROLETTE', 'SARGENT', 'SHERIDAN', 'SIOUX', 'SLOPE', 'STARK', 'STEELE', 'STUTSMAN', 'TOWNER', 'TRAILL', 'WALSH', 'WARD', 'WELLS', 'WILLIAMS'],
      M: ['ADAMS', 'BILLINGS', 'BOWMAN', 'GOLDEN VALLEY', 'GRANT', 'HETTINGER', 'SLOPE', 'STARK'], split: ['DUNN', 'MCKENZIE', 'SIOUX'] },
    SD: { zones: ['C', 'M'], def: 'C', all: ['AURORA', 'BEADLE', 'BENNETT', 'BON HOMME', 'BROOKINGS', 'BROWN', 'BRULE', 'BUFFALO', 'BUTTE', 'CAMPBELL', 'CHARLES MIX', 'CLARK', 'CLAY', 'CODINGTON', 'CORSON', 'CUSTER', 'DAVISON', 'DAY', 'DEUEL', 'DEWEY', 'DOUGLAS', 'EDMUNDS', 'FALL RIVER', 'FAULK', 'GRANT', 'GREGORY', 'HAAKON', 'HAMLIN', 'HAND', 'HANSON', 'HARDING', 'HUGHES', 'HUTCHINSON', 'HYDE', 'JACKSON', 'JERAULD', 'JONES', 'KINGSBURY', 'LAKE', 'LAWRENCE', 'LINCOLN', 'LYMAN', 'MARSHALL', 'MCCOOK', 'MCPHERSON', 'MEADE', 'MELLETTE', 'MINER', 'MINNEHAHA', 'MOODY', 'OGLALA LAKOTA', 'SHANNON', 'PENNINGTON', 'PERKINS', 'POTTER', 'ROBERTS', 'SANBORN', 'SPINK', 'STANLEY', 'SULLY', 'TODD', 'TRIPP', 'TURNER', 'UNION', 'WALWORTH', 'YANKTON', 'ZIEBACH'],
      M: ['BENNETT', 'BUTTE', 'CORSON', 'CUSTER', 'DEWEY', 'FALL RIVER', 'HAAKON', 'HARDING', 'JACKSON', 'LAWRENCE', 'MEADE', 'OGLALA LAKOTA', 'SHANNON', 'PENNINGTON', 'PERKINS', 'ZIEBACH'], split: ['STANLEY'] },
    KS: { zones: ['C', 'M'], def: 'C', M: ['SHERMAN', 'WALLACE', 'GREELEY', 'HAMILTON'], split: [] },
    TX: { zones: ['C', 'M'], def: 'C', M: ['EL PASO', 'HUDSPETH'], split: ['CULBERSON'] },
    // Navajo Nation keeps daylight time; the rest of Arizona does not.
    AZ: { zones: ['AZ', 'M'], def: 'AZ', split: ['APACHE', 'COCONINO', 'NAVAJO'] },
    NV: { zones: ['P', 'M'], def: 'P', split: ['ELKO'] },
    // Not tabled by county yet: always "not confident".
    NE: { zones: ['C', 'M'] }, ID: { zones: ['M', 'P'] }, OR: { zones: ['P', 'M'] },
    FL: { zones: ['E', 'C'] }, IN: { zones: ['E', 'C'] }, KY: { zones: ['E', 'C'] }, TN: { zones: ['E', 'C'] }, MI: { zones: ['E', 'C'] },
    AK: { zones: ['AK', 'AL'] },
  };
  // TASK-9922 r4 — WHICH SIDE of the line a site in a split county is on, from
  // the ticket's printed lat/lon. The line is the legal boundary (49 CFR 71.7)
  // as drawn by USDOT/BTS in the NTAD "Time Zones" layer (2023-01-05; built from
  // the 71.7 text with PLSS township lines, NHD river centrelines and county
  // lines). scripts/build-811-zone-boundary.cjs makes this table: the Mountain
  // polygon, simplified to within 150 m of the BTS line, clipped to one box per
  // region (box = [south, north, west, east]; m = rings of [lon, lat, ...]).
  // A point within L811_LINE_GUARD_M (1 mile) of the line, or outside the box,
  // decides nothing (the fail-safe band stays). Box edges are not the line.
  // AUTO-GENERATED DATA — re-run the script, never hand-edit.
  var L811_ZONE_LINE = {
    ND_W: { box: [47,48.3,-104.1,-102], counties: ["ND:MCKENZIE","ND:DUNN"],
      m: [[-104.1,47,-104.1,48.3,-104.04546,48.3,-104.04405,47.99616,-104.02126,47.98921,-104.01445,47.9809,-104.01172,47.97121,-104.00641,47.96729,-103.99786,47.96809,-103.98849,47.97318,-103.9858,47.98096,-103.97055,47.97269,-103.95924,47.9559,-103.96421,47.93264,-103.96423,47.91604,-103.96271,47.91141,-103.95573,47.90752,-103.95457,47.90247,-103.96042,47.87721,-103.9656,47.86947,-103.96882,47.84825,-103.79747,47.84829,-103.79769,47.67476,-103.73638,47.67476,-103.73649,47.58947,-103.60875,47.58962,-103.60885,47.51384,-103.59489,47.5149,-103.59519,47.51836,-103.60264,47.52102,-103.59936,47.52278,-103.59221,47.52082,-103.59249,47.51537,-103.58867,47.51155,-103.58122,47.51297,-103.57624,47.5186,-103.57025,47.51766,-103.56734,47.51477,-103.56901,47.50693,-103.56038,47.50661,-103.55613,47.50816,-103.55673,47.51131,-103.56336,47.51474,-103.54039,47.52203,-103.53804,47.52825,-103.54585,47.53152,-103.52943,47.53817,-103.5132,47.53443,-103.5081,47.52543,-103.50362,47.5268,-103.50135,47.53364,-103.49824,47.535,-103.49193,47.53282,-103.48423,47.52515,-103.4599,47.52769,-103.4573,47.52143,-103.45219,47.52424,-103.45346,47.53051,-103.43069,47.53072,-103.42783,47.54034,-103.44692,47.55486,-103.43181,47.57918,-103.43733,47.59057,-103.42961,47.59774,-103.42558,47.59637,-103.42877,47.5895,-103.41894,47.59191,-103.4084,47.58887,-103.39706,47.59241,-103.39123,47.59805,-103.38256,47.60144,-103.37214,47.60096,-103.36358,47.59331,-103.3553,47.59465,-103.34724,47.60002,-103.34268,47.59741,-103.34032,47.5891,-103.32725,47.59304,-103.31617,47.58894,-103.31117,47.59038,-103.30627,47.58641,-103.30698,47.57847,-103.30464,47.57749,-103.2935,47.57862,-103.28389,47.58268,-103.28041,47.59646,-103.27116,47.60013,-103.25942,47.59093,-103.22571,47.58752,-103.1963,47.57554,-103.18322,47.57263,-103.17112,47.57222,-103.16449,47.57844,-103.15834,47.57429,-103.15242,47.57465,-103.14979,47.5772,-103.15243,47.5836,-103.14967,47.58576,-103.14624,47.58622,-103.14397,47.58163,-103.14062,47.58085,-103.12801,47.58882,-103.11519,47.58585,-103.11043,47.58194,-103.08681,47.58448,-103.06796,47.57722,-103.0638,47.58517,-103.04683,47.59165,-103.053,47.60653,-103.04684,47.6081,-103.03476,47.6166,-103.02426,47.63284,-103.01714,47.63398,-103.01939,47.64347,-103.03698,47.65534,-103.0371,47.67337,-103.03291,47.6775,-103.02364,47.67882,-103.01445,47.67272,-103.01053,47.67795,-103.00646,47.67894,-102.99528,47.66631,-102.98411,47.66716,-102.98514,47.66167,-102.97425,47.66606,-102.96804,47.66434,-102.96487,47.65964,-102.96593,47.65239,-102.96094,47.65233,-102.95555,47.65572,-102.95152,47.64962,-102.95803,47.63994,-102.95302,47.6319,-102.94257,47.64143,-102.92914,47.63365,-102.924,47.62707,-102.91112,47.63228,-102.90327,47.63218,-102.8829,47.62399,-102.88143,47.61926,-102.88454,47.6141,-102.86642,47.6087,-102.8688,47.60252,-102.86682,47.60113,-102.84882,47.60376,-102.84469,47.60109,-102.84413,47.59614,-102.81614,47.60365,-102.81773,47.59619,-102.8029,47.60052,-102.79863,47.59131,-102.77094,47.59874,-102.75503,47.59298,-102.74549,47.57971,-102.735,47.57857,-102.7275,47.58049,-102.72288,47.57849,-102.70353,47.582,-102.69838,47.58105,-102.68601,47.57187,-102.68318,47.56474,-102.67661,47.55936,-102.68752,47.54938,-102.68759,47.54561,-102.68204,47.5358,-102.67342,47.53075,-102.66359,47.53067,-102.65057,47.53906,-102.62531,47.53952,-102.60129,47.54368,-102.59552,47.54297,-102.56811,47.52767,-102.52658,47.5158,-102.5091,47.51296,-102.43636,47.51254,-102.43994,47.53313,-102.43684,47.545,-102.44221,47.55614,-102.4413,47.57084,-102.42602,47.5748,-102.41706,47.58987,-102.3641,47.59247,-102.31743,47.60853,-102.29547,47.60691,-102.28356,47.61918,-102.26673,47.61598,-102.252,47.60679,-102.2334,47.60509,-102.20558,47.59603,-102.20557,47.32808,-102.14446,47.32809,-102.14487,47]] },
    ND_S: { box: [45.9,46.5,-101.9,-100.3], counties: ["ND:SIOUX"],
      m: [[-101.9,45.9,-101.9,46.5,-101.29892,46.5,-101.299,46.37141,-101.04854,46.37146,-101.04852,46.28454,-101.0257,46.28442,-101.02396,46.2787,-101.03645,46.27575,-101.03826,46.28007,-101.04472,46.28215,-101.05451,46.27804,-101.05758,46.27023,-101.08536,46.27552,-101.09623,46.27283,-101.09686,46.26812,-101.08852,46.26739,-101.09135,46.25806,-101.10538,46.25646,-101.1062,46.24955,-101.11684,46.24304,-101.11397,46.24007,-101.10541,46.24282,-101.10013,46.23021,-101.10161,46.22678,-101.11415,46.21985,-101.11615,46.21437,-101.12151,46.21413,-101.12501,46.21109,-101.13196,46.21437,-101.14325,46.20943,-101.14349,46.20336,-101.15738,46.1987,-101.16791,46.20204,-101.16949,46.19989,-101.16557,46.19712,-101.1712,46.19164,-101.17604,46.19511,-101.18746,46.19271,-101.19808,46.18378,-101.19805,46.18202,-101.192,46.18174,-101.19591,46.17587,-101.19259,46.1745,-101.19397,46.16806,-101.18894,46.16648,-101.18834,46.16321,-101.19584,46.16141,-101.19666,46.15894,-101.19038,46.14786,-101.19505,46.14772,-101.20047,46.15323,-101.21295,46.15612,-101.21616,46.14986,-101.22366,46.14972,-101.21954,46.14545,-101.22598,46.1425,-101.22815,46.13798,-101.23677,46.14309,-101.24117,46.13834,-101.24854,46.1424,-101.25152,46.13502,-101.26009,46.1398,-101.26611,46.13071,-101.27357,46.13631,-101.27555,46.12982,-101.28169,46.12946,-101.28173,46.1345,-101.28586,46.13535,-101.29287,46.13362,-101.29431,46.12743,-101.29714,46.12754,-101.29839,46.13195,-101.30171,46.13328,-101.30335,46.12745,-101.31137,46.12579,-101.30168,46.12011,-101.2979,46.12034,-101.29866,46.11698,-101.29472,46.11575,-101.30175,46.11006,-101.29993,46.10485,-101.30885,46.1043,-101.31916,46.10037,-101.31236,46.09194,-101.32274,46.09709,-101.3256,46.09108,-101.33379,46.0916,-101.33226,46.07934,-101.33894,46.05857,-101.33285,46.04361,-101.33806,46.02271,-101.33389,46.01184,-101.33392,45.94411,-100.49589,45.94365,-100.49069,45.93615,-100.44498,45.91022,-100.4338,45.9]] },
    SD_C: { box: [43.9,44.9,-101.8,-100], counties: ["SD:STANLEY"],
      m: [[-101.8,43.9,-101.8,44.9,-100.40019,44.9,-100.38959,44.88217,-100.39273,44.86603,-100.40381,44.85386,-100.44704,44.83447,-100.47888,44.8144,-100.49155,44.80469,-100.51647,44.77164,-100.52713,44.76507,-100.55653,44.75905,-100.58132,44.76314,-100.59618,44.76926,-100.62471,44.79019,-100.64755,44.82152,-100.67242,44.8289,-100.69633,44.8264,-100.70709,44.82121,-100.7182,44.81326,-100.72295,44.80168,-100.7222,44.77925,-100.71399,44.77675,-100.68903,44.76185,-100.66986,44.75482,-100.63838,44.73373,-100.62985,44.7219,-100.6235,44.68422,-100.62706,44.67441,-100.62808,44.64822,-100.63695,44.61706,-100.63396,44.59491,-100.62741,44.58208,-100.61838,44.57222,-100.60893,44.56666,-100.57335,44.56077,-100.5366,44.55906,-100.52115,44.55545,-100.51575,44.54736,-100.51238,44.53897,-100.5155,44.5293,-100.52071,44.52464,-100.53341,44.51727,-100.55931,44.51142,-100.57792,44.50087,-100.58352,44.48978,-100.58358,44.4813,-100.57963,44.47549,-100.56331,44.46557,-100.53918,44.46098,-100.47461,44.46875,-100.41026,44.46387,-100.39212,44.45595,-100.38728,44.44994,-100.38839,44.44432,-100.37982,44.42763,-100.37077,44.37357,-100.5465,44.16836,-101.04693,44.16849,-101.0468,43.99498,-101.06408,43.99494,-101.06424,43.9]] },
  };
  var L811_LINE_GUARD_M = 1609;
  /** Metres from point (x, y) to segment a-b, all in local metres. */
  function l811SegM(x, y, ax, ay, bx, by) {
    var dx = bx - ax; var dy = by - ay;
    var l2 = dx * dx + dy * dy;
    var t = l2 ? Math.max(0, Math.min(1, ((x - ax) * dx + (y - ay) * dy) / l2)) : 0;
    var px = ax + t * dx - x; var py = ay + t * dy - y;
    return Math.sqrt(px * px + py * py);
  }
  /** Metres from segment a-b to the rectangle [x1,x2] x [y1,y2] (0 when they touch), local metres. */
  function l811SegRectM(ax, ay, bx, by, x1, y1, x2, y2) {
    // Liang-Barsky: does the segment enter the rectangle?
    var t0 = 0; var t1 = 1; var dx = bx - ax; var dy = by - ay;
    var p = [-dx, dx, -dy, dy]; var q = [ax - x1, x2 - ax, ay - y1, y2 - ay];
    var hit = true;
    for (var i = 0; i < 4 && hit; i++) {
      if (p[i] === 0) { if (q[i] < 0) hit = false; } else {
        var r = q[i] / p[i];
        if (p[i] < 0) { if (r > t1) hit = false; else if (r > t0) t0 = r; } else if (r < t0) hit = false; else if (r < t1) t1 = r;
      }
    }
    if (hit) return 0;
    var cx = function (x) { return Math.max(x1, Math.min(x2, x)); };
    var cy = function (y) { return Math.max(y1, Math.min(y2, y)); };
    var d = Math.min(Math.sqrt(Math.pow(ax - cx(ax), 2) + Math.pow(ay - cy(ay), 2)), Math.sqrt(Math.pow(bx - cx(bx), 2) + Math.pow(by - cy(by), 2)));
    return Math.min(d, l811SegM(x1, y1, ax, ay, bx, by), l811SegM(x2, y1, ax, ay, bx, by), l811SegM(x1, y2, ax, ay, bx, by), l811SegM(x2, y2, ax, ay, bx, by));
  }
  /**
   * 'M' | 'C' for a site in a split county the table covers, '' when it decides
   * nothing. The site is the point (lat, lon), or the RECTANGLE spanned by it and
   * (lat2, lon2) — the ticket's dig box (COD r4: corners alone cannot prove a
   * winding line misses the box). Nothing is decided when the county has no
   * table, a number is missing / bad, the site is not wholly inside the region
   * box, or ANY part of the line comes within 1 mile of the site. Pure.
   */
  function l811LineZone(state, county, lat, lon, lat2, lon2) {
    var ok = function (v) { return typeof v === 'number' && isFinite(v); };
    if (!ok(lat) || !ok(lon)) return '';
    if (lat2 === undefined && lon2 === undefined) { lat2 = lat; lon2 = lon; }
    if (!ok(lat2) || !ok(lon2)) return '';
    var s = Math.min(lat, lat2); var n = Math.max(lat, lat2); var w = Math.min(lon, lon2); var e = Math.max(lon, lon2);
    var key = String(state || '').toUpperCase() + ':' + l811CountyKey(county);
    for (var r in L811_ZONE_LINE) {
      var g = L811_ZONE_LINE[r];
      if (g.counties.indexOf(key) < 0) continue;
      var b = g.box;
      if (s <= b[0] || n >= b[1] || w <= b[2] || e >= b[3]) return '';
      // Local metres about the site's centre (fine across a county).
      var la0 = (s + n) / 2; var lo0 = (w + e) / 2;
      var k = 111320 * Math.cos(la0 * Math.PI / 180);
      var X = function (v) { return (v - lo0) * k; };
      var Y = function (v) { return (v - la0) * 110574; };
      var x1 = X(w); var x2 = X(e); var y1 = Y(s); var y2 = Y(n);
      var inside = false;
      var near = Infinity;
      for (var i = 0; i < g.m.length; i++) {
        var ring = g.m[i];
        var np = ring.length / 2;
        for (var j = 0, m = np - 1; j < np; m = j++) {
          var ax = ring[2 * m]; var ay = ring[2 * m + 1]; var bx = ring[2 * j]; var by = ring[2 * j + 1];
          if ((ay > la0) !== (by > la0) && lo0 < ax + (la0 - ay) * (bx - ax) / (by - ay)) inside = !inside;
          // An edge lying ON the box is the clip, not the zone line.
          var onBox = (ax === bx && (ax === b[2] || ax === b[3])) || (ay === by && (ay === b[0] || ay === b[1]));
          if (!onBox) near = Math.min(near, l811SegRectM(X(ax), Y(ay), X(bx), Y(by), x1, y1, x2, y2));
        }
      }
      if (near < L811_LINE_GUARD_M) return '';
      return inside ? 'M' : 'C';
    }
    return '';
  }
  /** "McKenzie County" / "MC KENZIE" / "St. Louis" -> "MCKENZIE" / "MCKENZIE" / "ST LOUIS". */
  function l811CountyKey(c) {
    var s = String(c == null ? '' : c).toUpperCase().replace(/[^A-Z ]+/g, ' ').replace(/\s+/g, ' ').trim();
    s = s.replace(/\s+(COUNTY|CO|PARISH|BOROUGH)$/, '').replace(/^MC\s+/, 'MC').replace(/^SAINT\s+/, 'ST ');
    return s;
  }
  /**
   * The zone(s) a site in this state + county can be in:
   * { zones: [IANA...], confident } — confident = exactly one zone, known.
   * Unknown state -> { zones: [], confident: false }.
   */
  function l811SiteZones(state, county, pts) {
    var st = String(state == null ? '' : state).toUpperCase().replace(/[^A-Z]/g, '');
    if (L811_STATE_ZONE[st]) return { zones: [L811_TZ[L811_STATE_ZONE[st]]], confident: true };
    var sp = L811_SPLIT_STATE[st];
    if (!sp) return { zones: [], confident: false };
    var all = sp.zones.map(function (z) { return L811_TZ[z]; });
    var ck = l811CountyKey(county);
    // TASK-9922 r4 — a split county is decided by the printed points (pts = flat
    // [lat, lon, ...], the ticket's dig-box corners) when the line table covers
    // it: the WHOLE rectangle they span must be > 1 mile from the line (COD r4).
    if (ck && (sp.split || []).indexOf(ck) >= 0 && Array.isArray(pts) && pts.length >= 2 && pts.length % 2 === 0) {
      var s0 = Infinity; var n0 = -Infinity; var w0 = Infinity; var e0 = -Infinity;
      for (var q = 0; q < pts.length; q += 2) {
        if (typeof pts[q] !== 'number' || typeof pts[q + 1] !== 'number') { s0 = NaN; break; }
        s0 = Math.min(s0, pts[q]); n0 = Math.max(n0, pts[q]); w0 = Math.min(w0, pts[q + 1]); e0 = Math.max(e0, pts[q + 1]);
      }
      var lz = l811LineZone(st, ck, s0, w0, n0, e0);
      if (lz && sp.zones.indexOf(lz) >= 0) return { zones: [L811_TZ[lz]], confident: true, byPoint: true };
    }
    if (!sp.def || !ck || (sp.split || []).indexOf(ck) >= 0) return { zones: all, confident: false };
    for (var i = 0; i < sp.zones.length; i++) {
      var z = sp.zones[i];
      if (z !== sp.def && Array.isArray(sp[z]) && sp[z].indexOf(ck) >= 0) return { zones: [L811_TZ[z]], confident: true };
    }
    // Not an exception county. With the state's full county list, it must be ON
    // it (a misread name is not a county). Without one, a name within two letters
    // of an exception or split county may BE that county misread: not confident.
    if (Array.isArray(sp.all)) return sp.all.indexOf(ck) >= 0 ? { zones: [L811_TZ[sp.def]], confident: true } : { zones: all, confident: false };
    var near = (sp.split || []).slice();
    for (var j = 0; j < sp.zones.length; j++) if (Array.isArray(sp[sp.zones[j]])) near = near.concat(sp[sp.zones[j]]);
    for (var n = 0; n < near.length; n++) if (l811Lev(ck, near[n]) <= 2) return { zones: all, confident: false };
    return { zones: [L811_TZ[sp.def]], confident: true };
  }
  /** The ticket's site zones, from what the PDF reader stored. */
  function l811SiteZonesOf(p) {
    var loc = l811SiteLocationOf(p);
    var z = l811SiteZones(loc.state, loc.county, loc.pts);
    // A location DERIVED from the job / project (not read off the ticket) is never
    // confident, and it never NARROWS the fail-safe band either (COD r3: a project
    // address can be a yard or an office): l811DecisionZones adds the company
    // zone AND both neighbours, exactly as for an unknown location.
    if (loc.source === 'derived') return { zones: z.zones, confident: false, derived: true };
    return z;
  }
  /**
   * TASK-9922 r3 — where the ticket is: { state, county, source, lat, lon }.
   *   source 'pdf'     = read off the ticket (the PDF reader's readFromPdf.fields,
   *                      or siteLocation written by the backfill from the PDF text);
   *   source 'derived' = siteLocation taken from the job / project it is on;
   *   source ''        = not known.
   * TASK-9922 r4 — siteLocation is SERVER-ONLY (firestore.rules refuse a client
   * create / change of it; the backfill writes it with the Admin SDK), so a
   * 'pdf-text' siteLocation wins over the client-saved readFromPdf, and lat / lon
   * (the point that decides a split county) come ONLY from it. readFromPdf and a
   * 'pdf-text' siteLocation that name different states (or counties) = not known (fail-safe).
   */
  function l811SiteLocationOf(p) {
    var none = { state: '', county: '', source: '', pts: [] };
    if (!p || typeof p !== 'object') return none;
    var f = p.readFromPdf && typeof p.readFromPdf === 'object' && p.readFromPdf.fields && typeof p.readFromPdf.fields === 'object' ? p.readFromPdf.fields : {};
    // COD r3 round 2: a WHOLE two-letter code only. Slicing made "Montana" read
    // as "MO" (Central, confident) — anything else is no state (fail-safe band).
    var st = function (v) { var s = String(v == null ? '' : v).toUpperCase().replace(/[^A-Z]/g, ''); return s.length === 2 ? s : ''; };
    var ct = function (v) { return typeof v === 'string' ? v.slice(0, 60) : ''; };
    // pts = the printed points, flat [lat, lon, lat, lon, ...] (Firestore has no
    // nested arrays); anything malformed = no points.
    var pts = function (v) {
      if (!Array.isArray(v) || !v.length || v.length % 2 || v.length > 8) return [];
      for (var i = 0; i < v.length; i++) if (typeof v[i] !== 'number' || !isFinite(v[i])) return [];
      return v.slice();
    };
    var s = p.siteLocation && typeof p.siteLocation === 'object' ? p.siteLocation : null;
    if (s && s.source === 'pdf-text' && st(s.state)) {
      // COD r4: a different state OR (both named) a different county = not known.
      if (st(f.state) && (st(f.state) !== st(s.state) || (ct(f.county) && ct(s.county) && l811CountyKey(f.county) !== l811CountyKey(s.county)))) return none;
      return { state: st(s.state), county: ct(s.county), source: 'pdf', pts: pts(s.pts) };
    }
    if (st(f.state)) return { state: st(f.state), county: ct(f.county), source: 'pdf', pts: [] };
    if (s && st(s.state) && (s.source === 'project' || s.source === 'job')) return { state: st(s.state), county: ct(s.county), source: 'derived', pts: [] };
    return none;
  }
  /** TASK-9922 r3 — true when the ticket's time zone is a guess (unknown, a split county, or derived from the job / project). */
  function l811ZoneGuessed(p) {
    return !l811SiteZonesOf(p).confident;
  }
  var L811_DTF = {};
  function l811Dtf(tz) {
    if (!L811_DTF[tz]) L811_DTF[tz] = new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' });
    return L811_DTF[tz];
  }
  /** Minutes the zone is ahead of UTC at that instant (Central daylight = -300), or NaN. */
  function l811ZoneOffsetMin(tz, ms) {
    try {
      var parts = l811Dtf(tz).formatToParts(new Date(ms));
      var v = {};
      for (var i = 0; i < parts.length; i++) v[parts[i].type] = +parts[i].value;
      var wall = Date.UTC(v.year, v.month - 1, v.day, v.hour === 24 ? 0 : v.hour, v.minute, v.second);
      return Math.round((wall - Math.floor(ms / 1000) * 1000) / 60000);
    } catch (e) {
      return NaN;
    }
  }
  /**
   * The instant (UTC ms) of a wall-clock time in a zone: dateKey + minutes after
   * midnight (1440 = the next midnight). A time that happens twice (fall back)
   * gives the LATER one; a time skipped (spring forward) gives the instant just
   * after the gap. NaN when unreadable.
   */
  function l811ZonedInstant(dateKey, minutes, tz) {
    var k = l811ValidDateKey(dateKey);
    if (!k || typeof minutes !== 'number' || !isFinite(minutes)) return NaN;
    var guess = Date.UTC(+k.slice(0, 4), +k.slice(5, 7) - 1, +k.slice(8, 10)) + Math.round(minutes) * 60000;
    // The zone's offset a day either side of the guess covers both sides of a
    // DST change; a candidate is real when the zone's offset AT it is the one used.
    var offs = [l811ZoneOffsetMin(tz, guess - 30 * 36e5), l811ZoneOffsetMin(tz, guess), l811ZoneOffsetMin(tz, guess + 30 * 36e5)];
    var real = NaN;
    var any = NaN;
    for (var i = 0; i < offs.length; i++) {
      if (!isFinite(offs[i])) continue;
      var t = guess - offs[i] * 60000;
      if (!isFinite(any) || t > any) any = t;
      if (l811ZoneOffsetMin(tz, t) === offs[i] && (!isFinite(real) || t > real)) real = t;
    }
    return isFinite(real) ? real : any;
  }
  /** The zones a comparison uses: the site's when known, else the site candidates AND the company zone. */
  function l811DecisionZones(p, companyTz) {
    var co = companyTz || 'America/Chicago';
    var s = l811SiteZonesOf(p);
    if (s.confident) return { zones: s.zones, confident: true };
    var z = s.zones.slice();
    if (z.indexOf(co) < 0) z.push(co);
    // COD (Domain + Adversary, r1 + r2): NO state on file (older tickets, or one
    // the reader could not read) is not proof the site is in the company's zone.
    // A company works near home, so the zones one hour west AND one hour east of
    // the company's count too: the start takes the latest (the west one), the
    // expiry the earliest (the east one). A site two or more zones from home is
    // not covered; reading the state off the ticket is the real fix.
    if (!s.zones.length || s.derived) {
      var w = l811NeighborZone(co, -60);
      var e = l811NeighborZone(co, 60);
      if (w && z.indexOf(w) < 0) z.push(w);
      if (e && z.indexOf(e) < 0) z.push(e);
    }
    return { zones: z, confident: false };
  }
  /** The US zone whose standard time is `delta` minutes from tz's (-60: 'America/Chicago' -> 'America/Denver'), or ''. */
  function l811NeighborZone(tz, delta) {
    var jan = Date.UTC(2026, 0, 15, 12);
    var off = l811ZoneOffsetMin(tz, jan);
    if (!isFinite(off)) return '';
    var order = [L811_TZ.E, L811_TZ.C, L811_TZ.M, L811_TZ.P, L811_TZ.AK, L811_TZ.H];
    for (var i = 0; i < order.length; i++) if (l811ZoneOffsetMin(order[i], jan) === off + delta) return order[i];
    return '';
  }
  /**
   * TASK-9922 — the instant the ticket becomes clear to dig (UTC ms), or null
   * (no dig start). integ/2094 pre-ship (SAFETY): a renewal has a real start
   * too; whether its OLD ticket covers the time before it is
   * l811RenewalCovers' call, never this one's. The printed time is SITE time; no time read = the
   * whole dig-start day (clear at the next midnight). Not sure of the zone = the
   * LATEST of the candidates and the company zone (never clear early).
   * Returns { at, minutes, tz } — tz = the zone that set `at`.
   */
  function l811DigStartAt(p, companyTz) {
    if (!p || typeof p !== 'object') return null;
    var dig = l811ValidDateKey(p.digStartOn);
    if (!dig) return null;
    var m = l811DigStartMinutes(p);
    var dz = l811DecisionZones(p, companyTz);
    var out = null;
    for (var i = 0; i < dz.zones.length; i++) {
      var at = l811ZonedInstant(dig, m >= 0 ? m : 1440, dz.zones[i]);
      if (isFinite(at) && (!out || at > out.at)) out = { at: at, minutes: m, tz: dz.zones[i] };
    }
    // A zone name the clock cannot read (bad company setting): Central, and if even
    // that fails, never clear (fail safe, not open).
    if (!out) { var c = l811ZonedInstant(dig, m >= 0 ? m : 1440, 'America/Chicago'); out = { at: isFinite(c) ? c : Infinity, minutes: m, tz: 'America/Chicago' }; }
    return out;
  }
  /**
   * TASK-9922 — the instant the ticket stops being good (UTC ms): the end of its
   * good-through day in SITE time. Not sure of the zone = the EARLIEST of the
   * candidates and the company zone (never good late). null = no date.
   */
  function l811ExpiresAt(p, companyTz) {
    var exp = p && typeof p === 'object' ? l811ValidDateKey(p.expiresOn) : '';
    if (!exp) return null;
    var dz = l811DecisionZones(p, companyTz);
    var out = null;
    for (var i = 0; i < dz.zones.length; i++) {
      var at = l811ZonedInstant(exp, 1440, dz.zones[i]);
      if (isFinite(at) && (!out || at < out.at)) out = { at: at, tz: dz.zones[i] };
    }
    if (!out) { var c = l811ZonedInstant(exp, 1440, 'America/Chicago'); out = { at: isFinite(c) ? c : -Infinity, tz: 'America/Chicago' }; }
    return out;
  }
  /** "CT" / "MT" / "PT" / "AKT" for a zone at an instant ("CDT" -> "CT"), or ''. */
  function l811ZoneAbbr(tz, ms) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' }).formatToParts(new Date(ms));
      for (var i = 0; i < parts.length; i++) {
        if (parts[i].type === 'timeZoneName') {
          var n = parts[i].value;
          var m = /^([A-Z]{1,3})[SD]T$/.exec(n);
          return m ? m[1] + 'T' : n;
        }
      }
    } catch (e) { /* fall through */ }
    return '';
  }
  /** "7:00 AM" for minutes after midnight, '' when none. */
  function l811ClockText(m) {
    if (typeof m !== 'number' || m < 0 || m >= 1440) return '';
    var h = Math.floor(m / 60);
    var mm = m % 60;
    return (h % 12 === 0 ? 12 : h % 12) + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (h < 12 ? 'AM' : 'PM');
  }
  /**
   * TASK-9922 — the dig-start time as printed, with the zone it is in when that
   * zone is not the company's: { dateKey, time: '7:00 AM' | '', zone: 'MT' | '', at }.
   * null when there is no dig start.
   */
  function l811DigStartLabelParts(p, companyTz) {
    var d = l811DigStartAt(p, companyTz);
    if (!d) return null;
    var co = companyTz || 'America/Chicago';
    var time = l811ClockText(d.minutes);
    var differs = isFinite(d.at) && l811ZoneOffsetMin(d.tz, d.at - 60000) !== l811ZoneOffsetMin(co, d.at - 60000);
    return { dateKey: l811ValidDateKey(p.digStartOn), time: time, zone: time && differs ? l811ZoneAbbr(d.tz, d.at - 60000) : '', at: d.at };
  }
  /**
   * integ/2094 pre-ship (SAFETY) — the ticket a renewal renews, as it stood
   * before it was renewed, or null. Found with clock.ticketOf(id) (the caller's
   * own ticket list; no finder = null). Only when it was renewed BY p
   * (renewedById === p.id): a ticket not (yet) renewed, or renewed by another,
   * covers nothing. Its stored status became 'renewed' at the
   * renew; statusBeforeRenewed (written by the renew since integ/2094) is what
   * it was. A ticket renewed before that field existed reads as not clear.
   */
  function l811RenewedTicketOf(p, clock) {
    if (!p || typeof p !== 'object' || typeof p.renewsId !== 'string' || !p.renewsId) return null;
    var f = clock && typeof clock === 'object' && typeof clock.ticketOf === 'function' ? clock.ticketOf : null;
    if (!f) return null;
    var o = null;
    try { o = f(p.renewsId); } catch (e) { o = null; }
    if (!o || typeof o !== 'object') return null;
    if (o.id != null && o.id !== p.renewsId) return null;
    // COD (Adversary): the link must hold BOTH ways. The old ticket was renewed BY
    // this one (renewedById === p.id), so a renewsId pointed at any other live,
    // clear ticket covers nothing.
    if (typeof p.id !== 'string' || !p.id || o.renewedById !== p.id) return null;
    var v = {};
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) v[k] = o[k];
    v.id = p.renewsId;
    v.renewedById = '';
    v.status = o.statusBeforeRenewed === 'clear' ? 'clear' : 'requested';
    return v;
  }
  /** The clock one renew-chain step deeper, or null past 4 steps (a loop never clears). */
  function l811ChainClock(clock) {
    var d = clock && typeof clock === 'object' && typeof clock._depth === 'number' ? clock._depth : 0;
    if (d >= 4) return null;
    var c = {};
    for (var k in clock) if (Object.prototype.hasOwnProperty.call(clock, k)) c[k] = clock[k];
    c._depth = d + 1;
    return c;
  }
  /**
   * integ/2094 pre-ship (SAFETY) — does the ticket p renews cover THIS moment?
   * Only when it is found, unexpired and itself clear to dig now (its own dig
   * start passed or covered in turn, every utility marked). Anything else — not
   * a renewal, no finder, the old ticket gone, expired, waiting or not clear —
   * false, and p gets the normal start rule.
   */
  function l811RenewalCovers(p, todayKey, nowMinutes, clock) {
    var o = l811RenewedTicketOf(p, clock);
    // No good-through date on the old ticket = it cannot be shown to be good.
    if (!o || !l811ValidDateKey(o.expiresOn)) return false;
    var c = l811ChainClock(clock);
    if (!c) return false;
    return l811EffectiveStatus(o, todayKey, nowMinutes, c) === 'clear';
  }
  /**
   * integ/2094 pre-ship (SAFETY) — does the ticket p renews cover the job day
   * dayKey? It must be found and clear, with no hard stop of its own that day
   * (good through it, its own start not later); on TODAY with a clock it must
   * be clear at this instant too (l811RenewalCovers).
   */
  function l811RenewalCoversDay(p, dayKey, todayKey, clock) {
    var o = l811RenewedTicketOf(p, clock);
    if (!o || !l811MembersOf(o).clear || !l811ValidDateKey(o.expiresOn)) return false;
    var c = l811ChainClock(clock);
    if (!c) return false;
    if (l811HardStops([o], [dayKey], todayKey, c).length) return false;
    var timed = typeof c.now === 'number' && isFinite(c.now);
    if (timed && dayKey === l811ValidDateKey(todayKey)) return l811RenewalCovers(p, todayKey, -1, clock);
    return true;
  }
  /**
   * TASK-9920 (Alyse 10/16, SAFETY) — is the ticket still BEFORE its legal dig
   * start? A locate is NOT clear to dig before its work-to-begin date and time.
   *   - today before digStartOn -> true;
   *   - today IS digStartOn -> true until the printed start time has passed in
   *     the company zone; with no start time on file (or no clock passed) it
   *     stays true all that day (the safe direction: "Dig starts today").
   * A renewal (renewsId) is NOT before its start while the ticket it renews
   * covers that moment (l811RenewalCovers: present, unexpired and itself clear
   * — integ/2094 pre-ship, SAFETY); otherwise the normal rule. No digStartOn = false.
   * TASK-9922 — pass clock = { now: ms, tz: company zone } and the answer is
   * now < l811DigStartAt (SITE time, fail safe when the zone is not sure);
   * todayKey / nowMinutes are then not used. Without a clock: the date-only rule.
   */
  function l811BeforeDigStart(p, todayKey, nowMinutes, clock) {
    if (!p || typeof p !== 'object') return false;
    if (l811RenewalCovers(p, todayKey, nowMinutes, clock)) return false;
    if (clock && typeof clock === 'object' && typeof clock.now === 'number' && isFinite(clock.now)) {
      var ds = l811DigStartAt(p, clock.tz);
      return !!ds && clock.now < ds.at;
    }
    var dig = l811ValidDateKey(p.digStartOn);
    var today = l811ValidDateKey(todayKey);
    if (!dig || !today) return false;
    if (today < dig) return true;
    if (today > dig) return false;
    var start = l811DigStartMinutes(p);
    if (start < 0 || typeof nowMinutes !== 'number' || nowMinutes < 0) return true;
    return nowMinutes < start;
  }

  /**
   * requested | waiting | clear | expired | renewed. Renewed wins (the
   * replacement covers the site); then expired, from the date only, in the
   * company zone; then waiting (TASK-9920: before the legal dig start — never
   * "clear to dig"); then the stored status ('clear'), else requested.
   * nowMinutes (optional) = l811NowMinutes(tz) for the start-day time check.
   * TASK-9922 — clock (optional) = { now: ms, tz: company zone }: expired and
   * waiting are then judged at that instant in the SITE's zone (l811ExpiresAt /
   * l811DigStartAt, fail safe when the zone is not sure). Every screen that
   * tells someone whether they may dig passes it.
   * integ/2094 pre-ship — clock.ticketOf(id) (optional) finds the ticket a
   * renewal renews; without it a renewal gets the normal start rule.
   */
  function l811EffectiveStatus(p, todayKey, nowMinutes, clock) {
    if (!p || typeof p !== 'object') return 'requested';
    if (p.status === 'renewed' || (typeof p.renewedById === 'string' && p.renewedById)) return 'renewed';
    var timed = !!(clock && typeof clock === 'object' && typeof clock.now === 'number' && isFinite(clock.now));
    var exp = l811ValidDateKey(p.expiresOn);
    if (timed) {
      var ea = l811ExpiresAt(p, clock.tz);
      if (ea && clock.now >= ea.at) return 'expired';
    } else if (exp && l811ValidDateKey(todayKey) && exp < todayKey) return 'expired';
    if (l811BeforeDigStart(p, todayKey, nowMinutes, clock)) return 'waiting';
    // TASK-9925 (SAFETY) — 'requested' = past the dig start but NOT every utility
    // member has marked / cleared: "Waiting on utilities", never "Clear to dig".
    return l811MembersOf(p).clear ? 'clear' : 'requested';
  }

  /**
   * TASK-9925 (SAFETY) — the utility members' answers on file:
   *   { clear, responded, total } — clear = the stored status is 'clear' (the
   *   office marked every member cleared) and NOTHING else. COD r1: the PDF
   *   reader's allMembersClear is never trusted on its own (a member row on a
   *   page it missed reads as all clear, and the office could not take it back);
   *   it only feeds the counts. responded / total = the counts the reader saw,
   *   or null when not on file (older reads kept only the yes/no).
   * ND (NDCC 49-23-04(4)) lets an excavator start once ALL facilities are
   * located or cleared, or when the location period (or an extension the
   * notification center sends) runs out; MT (MCA 69-4-502(1)) needs the marks
   * or a positive response first. DispatchDeck cannot see an extension, so a
   * ticket is only ever "clear to dig" when the members say so.
   */
  function l811MembersOf(p) {
    var out = { clear: false, responded: null, total: null };
    if (!p || typeof p !== 'object') return out;
    var rp = p.readFromPdf;
    var f = rp && typeof rp === 'object' && rp.fields && typeof rp.fields === 'object' ? rp.fields : null;
    var cnt = function (v) { return typeof v === 'number' && isFinite(v) && v >= 0 && v <= 200 && Math.floor(v) === v ? v : null; };
    var total = f ? cnt(f.membersCount) : null;
    var responded = f ? cnt(f.membersClearCount) : null;
    if (total === null || total === 0 || responded === null || responded > total) { total = null; responded = null; }
    out.total = total;
    out.responded = responded;
    out.clear = p.status === 'clear';
    return out;
  }
  /**
   * TASK-9925 — "Waiting on utilities (2 of 5 responded)" / "Waiting on
   * utilities"; every member answered on the PDF but the office has not marked
   * it clear: "Utilities answered (5 of 5), not marked clear yet".
   */
  function l811UtilitiesLabel(p) {
    var m = l811MembersOf(p);
    if (m.total !== null && m.responded === m.total) return 'Utilities answered (' + m.responded + ' of ' + m.total + '), not marked clear yet';
    return 'Waiting on utilities' + (m.total !== null ? ' (' + m.responded + ' of ' + m.total + ' responded)' : '');
  }
  /**
   * TASK-9925 — the LAST company-calendar day the ticket is good, judged in the
   * dig SITE's zone: the earlier of expiresOn and the company date of the minute
   * before l811ExpiresAt (a site east of the company runs out before the
   * company's midnight). '' = no date.
   */
  function l811LastGoodDay(p, companyTz) {
    var exp = p && typeof p === 'object' ? l811ValidDateKey(p.expiresOn) : '';
    if (!exp) return '';
    var ea = l811ExpiresAt(p, companyTz);
    var k = ea && isFinite(ea.at) ? l811TodayKey(companyTz || 'America/Chicago', ea.at - 60000) : '';
    return k && k < exp ? k : exp;
  }
  /**
   * TASK-9925 — the FIRST company-calendar day digging may start on: the later
   * of digStartOn and the company date of l811DigStartAt (minus a minute, so a
   * midnight start belongs to the day before it). '' = no start. A renewal's own
   * start counts here too (integ/2094 pre-ship); hardStops forgives the days its
   * old ticket covers.
   */
  function l811FirstDigDay(p, companyTz) {
    if (!p || typeof p !== 'object') return '';
    var dig = l811ValidDateKey(p.digStartOn);
    if (!dig) return '';
    // COD r1 (Edge): no start time read = the printed day itself. digStartAt then
    // means "the next midnight" (site zone), which for a site west of the company
    // falls on the company's NEXT day and would hard-stop the printed dig day.
    if (l811DigStartMinutes(p) < 0) return dig;
    var ds = l811DigStartAt(p, companyTz);
    var k = ds && isFinite(ds.at) ? l811TodayKey(companyTz || 'America/Chicago', ds.at) : '';
    return k && k > dig ? k : dig;
  }

  /**
   * THE HARD STOP. `tickets` = every ticket linked to the job: its own AND its
   * project's (the caller resolves both). `dayKeys` = the job days being saved.
   * A day counts when it is today or later (pass '' as todayKey to judge every
   * day, e.g. the driver screen) AND either
   *   - after a ticket's good-through date (reason 'expired'), or
   *   - before its dig-start date (reason 'early' — COD 10/14 Domain: digging
   *     before the legal start is the same failure as digging on an expired one).
   * Renewed tickets are skipped (their links moved to the replacement); a date
   * that is not on the ticket cannot be judged and is skipped.
   * Returns [{ permit, reason, expiresOn, digStartOn, lateKeys }] (lateKeys =
   * the offending days) — empty = nothing blocks. A ticket that is both expired
   * and early for different days appears once per reason.
   * TASK-9925 — clock (optional) = { now: ms, tz: company zone }: the card's own
   * SITE-zone rule. A day is late after l811LastGoodDay, early before
   * l811FirstDigDay, and TODAY is late too once the ticket has run out at this
   * instant (l811ExpiresAt). Without a clock: the date-only rule.
   * Waiting on utilities (TASK-9925) is shown, never a hard stop.
   * integ/2094 pre-ship — clock.ticketOf(id) (optional, see l811RenewalCovers)
   * lets a renewal's early days be covered by the ticket it renews.
   */
  function l811HardStops(tickets, dayKeys, todayKey, clock) {
    var out = [];
    var list = Array.isArray(tickets) ? tickets : [];
    var days = [];
    var seenDay = {};
    var src = Array.isArray(dayKeys) ? dayKeys : [];
    for (var d = 0; d < src.length; d++) {
      var k = l811ValidDateKey(src[d]);
      if (k && !seenDay[k]) { seenDay[k] = 1; days.push(k); }
    }
    days.sort();
    var today = l811ValidDateKey(todayKey);
    var timed = !!(clock && typeof clock === 'object' && typeof clock.now === 'number' && isFinite(clock.now));
    var seen = {};
    for (var i = 0; i < list.length; i++) {
      var p = list[i];
      if (!p || !p.id || seen[p.id]) continue;
      seen[p.id] = 1;
      if (l811EffectiveStatus(p, today) === 'renewed') continue;
      var exp = timed ? l811LastGoodDay(p, clock.tz) : l811ValidDateKey(p.expiresOn);
      // A RENEWAL (renewsId) continues work its old ticket covers (COD r2 Domain),
      // but ONLY the days that old ticket covers: present, good that day and
      // itself clear (integ/2094 pre-ship, SAFETY). Any other day before the
      // renewal's own start is early, the normal rule.
      var dig = timed ? l811FirstDigDay(p, clock.tz) : l811ValidDateKey(p.digStartOn);
      var gone = false; // TASK-9925 — run out at this instant (site zone)
      if (timed && today) { var ea = l811ExpiresAt(p, clock.tz); gone = !!ea && clock.now >= ea.at; }
      var late = [];
      var early = [];
      for (var j = 0; j < days.length; j++) {
        if (today && days[j] < today) continue;
        if ((exp && days[j] > exp) || (gone && days[j] === today)) late.push(days[j]);
        else if (dig && days[j] < dig && !l811RenewalCoversDay(p, days[j], today, clock)) early.push(days[j]);
      }
      // The dates as printed on the ticket (the dialog shows them); the compare above may be a day tighter.
      var pExp = l811ValidDateKey(p.expiresOn);
      var pDig = dig ? l811ValidDateKey(p.digStartOn) : '';
      if (late.length) out.push({ permit: p, reason: 'expired', expiresOn: pExp, digStartOn: pDig, lateKeys: late });
      if (early.length) out.push({ permit: p, reason: 'early', expiresOn: pExp, digStartOn: pDig, lateKeys: early });
    }
    return out;
  }

  /** Replace oldId with newId in an id list, keeping its place, no repeats. */
  function l811SwapId(ids, oldId, newId) {
    var out = [];
    var list = Array.isArray(ids) ? ids : [];
    for (var i = 0; i < list.length; i++) {
      var id = typeof list[i] === 'string' ? list[i].trim() : '';
      if (!id) continue;
      if (id === oldId) id = newId;
      if (out.indexOf(id) < 0) out.push(id);
    }
    return out;
  }

  /**
   * Renew plan: every job (permitIds + legacy permitId) and project (permitIds)
   * that links oldId gets newId in its place. Returns
   * { jobs: [{ id, permitIds, permitId }], projects: [{ id, permitIds }] }.
   */
  function l811RenewPlan(oldId, newId, jobs, projects) {
    var plan = { jobs: [], projects: [] };
    if (!oldId || !newId || oldId === newId) return plan;
    var js = Array.isArray(jobs) ? jobs : [];
    for (var i = 0; i < js.length; i++) {
      var j = js[i];
      if (!j || !j.id) continue;
      var ids = Array.isArray(j.permitIds) ? j.permitIds.slice() : [];
      if (j.permitId && ids.indexOf(j.permitId) < 0) ids.unshift(j.permitId);
      if (ids.indexOf(oldId) < 0) continue;
      var next = l811SwapId(ids, oldId, newId);
      plan.jobs.push({ id: j.id, permitIds: next, permitId: next[0] || null });
    }
    var ps = Array.isArray(projects) ? projects : [];
    for (var k = 0; k < ps.length; k++) {
      var p = ps[k];
      if (!p || !p.id || !Array.isArray(p.permitIds) || p.permitIds.indexOf(oldId) < 0) continue;
      plan.projects.push({ id: p.id, permitIds: l811SwapId(p.permitIds, oldId, newId) });
    }
    return plan;
  }

  // ---- Name similarity (same algorithm as dispatch.js _p811Similarity) ----------
  function l811NormForMatch(s) {
    return String(s == null ? '' : s).toLowerCase().replace(/[^a-z0-9\s]+/g, '').replace(/\s+/g, ' ').trim();
  }
  function l811Lev(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    var prev = [];
    for (var j0 = 0; j0 <= b.length; j0++) prev.push(j0);
    for (var i = 1; i <= a.length; i++) {
      var cur = [i];
      for (var j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      }
      prev = cur;
    }
    return prev[b.length];
  }
  function l811SimilarityLetters(A, B) {
    var a2 = A.replace(/ /g, '');
    var b2 = B.replace(/ /g, '');
    if (a2 === b2) return 1;
    var lev = 1 - l811Lev(a2, b2) / Math.max(a2.length, b2.length);
    var ta = {}, tb = {}, na = 0, nb = 0, inter = 0;
    A.split(' ').forEach(function (t) { if (!ta[t]) { ta[t] = 1; na++; } });
    B.split(' ').forEach(function (t) { if (!tb[t]) { tb[t] = 1; nb++; } });
    for (var t in ta) if (Object.prototype.hasOwnProperty.call(ta, t) && tb[t]) inter++;
    var jac = inter / (na + nb - inter);
    return Math.max(lev, jac);
  }
  /** 0..1. Names that both carry numbers must carry the SAME numbers (a different pad is a different site). */
  function l811Similarity(a, b) {
    var A = l811NormForMatch(a), B = l811NormForMatch(b);
    if (!A || !B) return 0;
    var digits = function (x) { return (x.replace(/[^0-9 ]+/g, ' ').match(/[0-9]+/g) || []).join(' '); };
    var dA = digits(A.replace(/([0-9]) ([0-9])/g, '$1$2'));
    var dB = digits(B.replace(/([0-9]) ([0-9])/g, '$1$2'));
    if (dA && dB && dA !== dB) return Math.min(0.5, l811SimilarityLetters(A, B));
    return l811SimilarityLetters(A, B);
  }
  /** Best { item, score } whose name scores >= min (default 0.8), or null. Ties keep list order. */
  function l811BestMatch(name, items, nameOf, min) {
    var floor = typeof min === 'number' ? min : L811_MATCH_MIN;
    var best = null;
    var list = Array.isArray(items) ? items : [];
    for (var i = 0; i < list.length; i++) {
      var score = l811Similarity(name, nameOf(list[i]));
      if (score >= floor && (!best || score > best.score)) best = { item: list[i], score: score };
    }
    return best;
  }

  /**
   * Township/range/section keys from a ticket's legal-location text:
   * "T-157N R-90W S-18NW", "Twp 157N Rng 90W Sect-qtr 7-NW" -> ['157N-90W-18', '157N-90W-7'].
   * Two tickets that share one are at the same place.
   */
  function l811LegalKeys(text) {
    var s = String(text || '').toUpperCase();
    var out = [];
    var push = function (t, r, sec) {
      var k = parseInt(t, 10) + t.replace(/^\d+/, '') + '-' + parseInt(r, 10) + r.replace(/^\d+/, '') + '-' + parseInt(sec, 10);
      if (out.indexOf(k) < 0) out.push(k);
    };
    var re1 = /T-?\s*(\d{2,3}[NS])\s*,?\s*R-?\s*(\d{1,3}[EW])\s*,?\s*S-?\s*(\d{1,2})(?!\d)/g;
    var m;
    while ((m = re1.exec(s))) push(m[1], m[2], m[3]);
    var re2 = /TWP\s*(\d{2,3}[NS])\s*RNG\s*(\d{1,3}[EW])\s*SECT?(?:-?QTR)?\s*(\d{1,2})(?!\d)/g;
    while ((m = re2.exec(s))) push(m[1], m[2], m[3]);
    return out;
  }

  /**
   * The site suggestion for a freshly read ticket, in order of trust:
   *   1. "location": another ticket of the SAME customer at the same
   *      township/range/section already has a site name -> that spelling;
   *   2. "existing": the reader's proposed name is close (>= 0.8) to a known
   *      site / project / job name -> that spelling;
   *   3. "ticket": the reader's proposed short name as-is.
   * candidates: [{ name, source: 'site'|'project'|'job', customerId, legalKeys }].
   * Returns { name, source, matched } or null.
   */
  /**
   * TASK-9887 — the reader likes to lead a NEW site name with the customer's own
   * name ("Prairie Rose Hovland 14-23H" for Prairie Rose Pipeline). The card
   * already shows the customer and the office names the place, so a leading run
   * of a customer's first words is dropped when two or more words are left. An
   * owner / operator that is not a customer ("Devon Lonnie" for Stellar) stays.
   * names = the MATCHED customer's name only (COD: passing every customer turned
   * "Devon Lonnie 14-23H" for Stellar into "Lonnie 14-23H" when Devon is also a customer).
   */
  function l811StripCustomerPrefix(site, names) {
    var clean = l811CleanText(site);
    var words = clean.split(' ');
    var list = Array.isArray(names) ? names : [];
    var best = 0;
    for (var i = 0; i < list.length; i++) {
      var cw = l811NormForMatch(list[i]).split(' ').filter(Boolean);
      if (!cw.length || cw[0].length < 3) continue;
      var n = 0;
      while (n < cw.length && n < words.length && l811NormForMatch(words[n]) === cw[n]) n++;
      // ...or its initials ("NPM State 1-36 SWD" for Northern Plains Midstream).
      var ini = cw.filter(function (x) { return ['llc', 'inc', 'co', 'corp', 'ltd', 'lp', 'the', 'and'].indexOf(x) < 0; })
        .map(function (x) { return x.charAt(0); }).join('');
      if (!n && ini.length >= 2 && l811NormForMatch(words[0]) === ini) n = 1;
      if (n > best) best = n;
    }
    return best && words.length - best >= 2 ? words.slice(best).join(' ') : clean;
  }

  function l811SuggestSite(proposed, legalKeys, customerId, candidates) {
    var list = Array.isArray(candidates) ? candidates : [];
    var keys = Array.isArray(legalKeys) ? legalKeys : [];
    if (keys.length) {
      for (var i = 0; i < list.length; i++) {
        var c = list[i];
        if (!c || c.source !== 'site' || !c.name || !Array.isArray(c.legalKeys)) continue;
        if (customerId && c.customerId && c.customerId !== customerId) continue;
        for (var k = 0; k < keys.length; k++) {
          if (c.legalKeys.indexOf(keys[k]) >= 0) return { name: l811CleanText(c.name), source: 'location', matched: c.name };
        }
      }
    }
    var clean = l811CleanText(proposed);
    if (!clean) return null;
    var mine = list.filter(function (c) { return c && c.name && (!customerId || !c.customerId || c.customerId === customerId); });
    var hit = l811BestMatch(clean, mine, function (c) { return c.name; });
    if (hit) return { name: l811CleanText(hit.item.name), source: 'existing', matched: hit.item.name };
    // A known name of 2+ words that the reader's name fully contains
    // ("Bridger Lostwood" inside "Bridger Lostwood 12in") is the same site;
    // the longest such name wins.
    var words = l811NormForMatch(clean).split(' ');
    var within = null;
    for (var w = 0; w < mine.length; w++) {
      var cw = l811NormForMatch(mine[w].name).split(' ').filter(Boolean);
      if (cw.length < 2) continue;
      var all = true;
      for (var x = 0; x < cw.length; x++) if (words.indexOf(cw[x]) < 0) { all = false; break; }
      if (all && (!within || cw.length > within.n)) within = { n: cw.length, c: mine[w] };
    }
    if (within) return { name: l811CleanText(within.c.name), source: 'existing', matched: within.c.name };
    return { name: clean, source: 'ticket', matched: '' };
  }

  window.Locates811 = Object.freeze({
    SITE_MAX: L811_SITE_MAX,
    TICKET_NO_MAX: L811_TICKET_NO_MAX,
    STORED_STATUSES: L811_STORED_STATUSES,
    STATUSES: L811_STATUSES,
    ID_RE: L811_ID_RE,
    MATCH_MIN: L811_MATCH_MIN,
    cleanText: l811CleanText,
    siteNameOf: l811SiteNameOf,
    siteKey: l811SiteKey,
    groupKey: l811GroupKey,
    groupTickets: l811GroupTickets,
    ticketNoFromFile: l811TicketNoFromFile,
    siteFromFile: l811SiteFromFile,
    validDateKey: l811ValidDateKey,
    addDays: l811AddDays,
    todayKey: l811TodayKey,
    printedDateKey: l811PrintedDateKey,
    printedMinutes: l811PrintedMinutes,
    goodThroughFromPrinted: l811GoodThroughFromPrinted,
    effectiveStatus: l811EffectiveStatus,
    hardStops: l811HardStops,
    swapId: l811SwapId,
    renewPlan: l811RenewPlan,
    similarity: l811Similarity,
    bestMatch: l811BestMatch,
    legalKeys: l811LegalKeys,
    suggestSite: l811SuggestSite,
    stripCustomerPrefix: l811StripCustomerPrefix,
    nowMinutes: l811NowMinutes,
    digStartMinutes: l811DigStartMinutes,
    beforeDigStart: l811BeforeDigStart,
    renewalCovers: l811RenewalCovers,
    siteZones: l811SiteZones,
    siteZonesOf: l811SiteZonesOf,
    countyKey: l811CountyKey,
    zoneOffsetMin: l811ZoneOffsetMin,
    zonedInstant: l811ZonedInstant,
    digStartAt: l811DigStartAt,
    expiresAt: l811ExpiresAt,
    zoneAbbr: l811ZoneAbbr,
    clockText: l811ClockText,
    digStartLabelParts: l811DigStartLabelParts,
    siteLocationOf: l811SiteLocationOf,
    zoneGuessed: l811ZoneGuessed,
    membersOf: l811MembersOf,
    utilitiesLabel: l811UtilitiesLabel,
    lastGoodDay: l811LastGoodDay,
    firstDigDay: l811FirstDigDay,
    lineZone: l811LineZone
  });
})();
